import templateImage from '@/features/destinations/components/template-image';
import { Row } from '@tanstack/react-table';

type DestinationNameColumnProps<T extends { name: string }> = {
  row: Row<T>;
};

export const DestinationNameColumn = <T extends { name: string }>({ row }: DestinationNameColumnProps<T>) => {
  const item = row.original;

  return (
    <div className='flex items-center gap-3'>
      {templateImage(item.name, 8) || (
        <div className='flex size-6 items-center justify-center rounded-full bg-blue-500'>
          <span className='text-xs font-medium text-white-100'>{item.name.charAt(0).toUpperCase()}</span>
        </div>
      )}
      <div className='ml-2 min-w-0 flex-1'>
        <p className='truncate text-sm font-medium text-primary-900'>{item.name}</p>
      </div>
    </div>
  );
};
